export default __webpack_public_path__ + "static/media/tauroReal01DownloadMT4.1727e05c.jpg";